import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Logo } from "@/components/site/Reveal";

// Page de confirmation affichée après un paiement réussi via un lien de
// paiement Stripe (la redirection n'a lieu qu'en cas de paiement abouti).
export default function PaymentSuccess() {
  return (
    <div className="min-h-screen bg-obsidian text-chalk font-sans flex items-center justify-center px-5">
      <div className="max-w-md w-full text-center rounded-3xl border border-white/10 bg-coal p-9" data-testid="payment-success-page">
        <div className="flex justify-center mb-8"><Logo size={44} /></div>
        <CheckCircle2 size={52} className="mx-auto text-gold" data-testid="payment-confirmed-icon" />
        <h1 className="mt-6 font-heading text-3xl font-extrabold uppercase">Bienvenue à bord !</h1>
        <p className="mt-4 text-sm sm:text-base text-slate-300 leading-relaxed">
          Votre paiement est confirmé. Vous allez recevoir dans quelques minutes un email
          contenant votre code d'accès personnel à Boussole (pensez à vérifier vos spams).
        </p>
        <a
          href="https://boussole.yassineabou.fr/connexion"
          data-testid="payment-success-boussole-link"
          className="mt-6 inline-flex items-center justify-center rounded-full bg-gold text-obsidian px-7 py-3.5 text-xs font-bold uppercase tracking-wide"
        >
          Accéder à Boussole
        </a>
        <p className="mt-4 text-xs text-slate-500">Si vous avez choisi l'accompagnement individuel, Yassine vous contacte aussi sous 24h. Un reçu Stripe vous a été envoyé par email.</p>
        <Link
          to="/"
          data-testid="payment-success-home-link"
          className="mt-8 inline-flex items-center justify-center rounded-full bg-ember hover:bg-emberdark px-7 py-3.5 text-xs font-bold uppercase tracking-wide transition-colors duration-200"
        >
          Retour au site
        </Link>
      </div>
    </div>
  );
}
